<template>
  <div class="bidders-list tab-table">
    <settlement-table :hide-actions="hideActions" :accounting-system-params="{sale_no: sale.sale_no}"
                      :exclude-search-fields="['sale_no']" enable-frontend-export/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import SettlementTable from "../../../settlements/SettlementTable";
  import {ACTION_CREATE_MANUAL_INTRODUCTORY_SETTLEMENT, ACTION_CREATE_MANUAL_SETTLEMENT} from "../../../constants";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: settlementsMapActions} = createNamespacedHelpers('settlements');

  export default {
    name: "SettlementsList",
    components: {SettlementTable},
    data() {
      return {
        hideActions: [
          ACTION_CREATE_MANUAL_SETTLEMENT,
          ACTION_CREATE_MANUAL_INTRODUCTORY_SETTLEMENT
        ],
      }
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...settlementsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale,
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
